/** @format */

import React, { useEffect, useRef, useState } from "react";
import desk from "../../images/enquiry/desk.png";
import { userWalkinUpdate } from "../../data/ApiEndpoints";
import { useUpdateFetch } from "../../data/Queries";
import { toast } from "react-toastify";

const Presentation = ({ token, userDetails, next }) => {
  const { mutateAsync: updateUserWalkin, isLoading: isLoadingUserWalkin } =
    useUpdateFetch({
      key: userWalkinUpdate,
      token,
      url: userWalkinUpdate,
    });
  const [startTime, setStartTime] = useState(null);
  const [elapsedTime, setElapsedTime] = useState(0);
  const timerRef = useRef(null);

  useEffect(() => {
    if (startTime) {
      timerRef.current = setInterval(() => {
        setElapsedTime((prevElapsedTime) => prevElapsedTime + 1000);
      }, 1000);
    }

    return () => {
      clearInterval(timerRef.current);
    };
  }, [startTime]);

  const startTour = () => {
    try {
      if (!startTime) {
        setStartTime(new Date());
      }
    } catch (error) {
      console.log(error);
    }
  };

  const endTour = () => {
    try {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        handleNext();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const formatTime = (time) => {
    const hours = Math.floor(time / (60 * 60 * 1000));
    const minutes = Math.floor((time % (60 * 60 * 1000)) / (60 * 1000));
    const seconds = Math.floor((time % (60 * 1000)) / 1000);

    return {
      hours: `${String(hours).padStart(2, "0")}`,
      minutes: `${String(minutes).padStart(2, "0")}`,
      seconds: `${String(seconds).padStart(2, "0")}`,
    };
  };

  async function handleNext() {
    try {
      const time = formatTime(elapsedTime);
      const duration = `${time?.hours}:${time?.minutes}:${time?.seconds}`;

      const data = {
        uid: userDetails?.uid,
        status: 1,
        membership_presentation: duration,
        walk_in_type: "follow_up",
      };

      const { status, message } = await updateUserWalkin({ data });

      if (status) {
        toast.success(message);
        next();
      } else {
        toast.error(message);
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div>
      <div className="presentation-box">
        <img src={desk} alt="desk" />
      </div>

      <div className="timer-wrapper">
        <div className="flex-k px-2 js-between-k items-center-k">
          <div className="flex-k items-center-k gap-05-k">
            <span className="timer-box fs-4 small bolder-text dark-bg-k p-2 rounded-2">
              {formatTime(elapsedTime).hours}
            </span>
            <span className="bolder-text fs-4">:</span>
            <span className="timer-box fs-4 small bolder-text dark-bg-k p-2 rounded-2">
              {formatTime(elapsedTime).minutes}
            </span>
            <span className="bolder-text fs-4">:</span>
            <span className="timer-box fs-4 small bolder-text dark-bg-k p-2 rounded-2">
              {formatTime(elapsedTime).seconds}
            </span>
          </div>
          <div className="grid-k my-3">
            <button
              className="btn-k btn-primary-k"
              onClick={!elapsedTime ? startTour : endTour}
            >
              {!elapsedTime ? "Start Presentation" : "End Presentation"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Presentation;
